(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["link_item_blog"] && !Shopify.designMode) return;
  try {
    
theme.customLinkedBlog = function(sectionId, settings) {
  theme.customLinkedBlog.init(sectionId, settings);
};

  } catch(e) { console.error(e); }
})();
})();
